import { defineMessage } from '@lingui/macro';

const READY_TO_WELD = 'READY_TO_WELD',
  VT_SENT_BACK = 'VT_SENT_BACK',
  BLOCKED = 'BLOCKED',
  FITUP_INSPECTION = 'FITUP_INSPECTION',
  CLAIMED = 'CLAIMED',
  ASSIGNED = 'ASSIGNED',
  VT_APPROVED = 'VT_APPROVED',
  SENT_BACK_TO_PIPING = 'SENT_BACK_TO_PIPING',
  UNPLANNED = 'UNPLANNED',
  FITUP_REQUESTED = 'FITUP_REQUESTED',
  UNASSIGNED = 'UNASSIGNED';

export const WeldStatusMessages = {
  [READY_TO_WELD]: defineMessage({ message: `Ready to Weld` }),
  [VT_SENT_BACK]: defineMessage({ message: `VT Sent Back` }),
  [BLOCKED]: defineMessage({ message: `Blocked` }),
  [FITUP_INSPECTION]: defineMessage({ message: `Fitup Inspection` }),
  [CLAIMED]: defineMessage({ message: `Claimed` }),
  [ASSIGNED]: defineMessage({ message: `Assigned` }),
  [VT_APPROVED]: defineMessage({ message: `VT Approved` }),
  [SENT_BACK_TO_PIPING]: defineMessage({ message: `Sent Back to Piping` }),
  [UNPLANNED]: defineMessage({ message: `Unplanned` }),
  [UNASSIGNED]: defineMessage({ message: `Unassigned` }),
  [FITUP_REQUESTED]: defineMessage({ message: `Fitup Requested` }),
};

const INCORRECT_WELD_CLAIMED = 'INCORRECT_WELD_CLAIMED',
  WELD_SURFACE_ISSUE = 'WELD_SURFACE_ISSUE',
  WORK_NOT_DONE_INCOMPLETE = 'WORK_NOT_DONE_INCOMPLETE',
  MISSING_INCORRECT_STENCILS = 'MISSING_INCORRECT_STENCILS',
  MISSING_WELD_TAG = 'MISSING_WELD_TAG',
  OTHER_REASON = 'OTHER_REASON',
  JOINT_NOT_READY_FOR_FITUP = 'JOINT_NOT_READY_FOR_FITUP',
  FITUP_ALIGNMENT_ISSUE = 'FITUP_ALIGNMENT_ISSUE',
  JOINT_CLEANLINESS = 'JOINT_CLEANLINESS',
  ADEQUATE_PROTECTION_ACCESSIBILITY = 'ADEQUATE_PROTECTION_ACCESSIBILITY',
  ADEQUATE_PROTECTION = 'ADEQUATE_PROTECTION',
  ROOT_OPENING = 'ROOT_OPENING',
  CLEANLINESS = 'CLEANLINESS',
  ACCESSIBILITY = 'ACCESSIBILITY',
  BEVEL_PREP = 'BEVEL_PREP',
  MISMATCH = 'MISMATCH',
  WORK_NOT_COMPLETE = 'WORK_NOT_COMPLETE',
  IMPROPER_DOCUMENTATION = 'IMPROPER_DOCUMENTATION',
  INCORRECT_MATERIALS = 'INCORRECT_MATERIALS',
  WORK_NOT_RELEASED_YET = 'WORK_NOT_RELEASED_YET',
  INSTALLATION_NOT_TO_STANDARDS = 'INSTALLATION_NOT_TO_STANDARDS',
  FIELD_ENGINEERING_DISCLOSURE = 'FIELD_ENGINEERING_DISCLOSURE';

export const SendBackReasonMessages = {
  [INCORRECT_WELD_CLAIMED]: defineMessage({ message: `Incorrect Weld Claimed` }),
  [WELD_SURFACE_ISSUE]: defineMessage({ message: `Weld Surface Issue` }),
  [WORK_NOT_DONE_INCOMPLETE]: defineMessage({
    message: `Work Not Done/Incomplete`,
  }),
  [MISSING_INCORRECT_STENCILS]: defineMessage({
    message: `Missing/Incorrect Stencils`,
  }),
  [MISSING_WELD_TAG]: defineMessage({ message: `Missing Weld Tag` }),
  [OTHER_REASON]: defineMessage({ message: `Other` }),
  [JOINT_NOT_READY_FOR_FITUP]: defineMessage({
    message: `Joint Not Ready For Fitup`,
  }),
  [FITUP_ALIGNMENT_ISSUE]: defineMessage({ message: `Fitup/Alignment issue` }),
  [JOINT_CLEANLINESS]: defineMessage({ message: `Joint Cleanliness` }),
  [ADEQUATE_PROTECTION_ACCESSIBILITY]: defineMessage({
    message: `Adequate Protection/Accessibility`,
  }),
  [CLEANLINESS]: defineMessage({
    message: `Cleanliness`,
  }),
  [ACCESSIBILITY]: defineMessage({
    message: `Accessibility`,
  }),
  [ADEQUATE_PROTECTION]: defineMessage({
    message: `Adequate Protection`,
  }),

  [WORK_NOT_COMPLETE]: defineMessage({
    message: `Work not complete`,
  }),
  [IMPROPER_DOCUMENTATION]: defineMessage({
    message: `Improper documentation`,
  }),
  [INCORRECT_MATERIALS]: defineMessage({
    message: `Incorrect Material`,
  }),
  [WORK_NOT_RELEASED_YET]: defineMessage({
    message: `Work not released yet`,
  }),
  [INSTALLATION_NOT_TO_STANDARDS]: defineMessage({
    message: `Installation not to standards`,
  }),
  [FIELD_ENGINEERING_DISCLOSURE]: defineMessage({
    message: `Field engineer disclosure`,
  }),
};

const SURFACE_CONTOUR = 'SURFACE_CONTOUR',
  WELD_SPATTER = 'WELD_SPATTER',
  ARC_STRIKES = 'ARC_STRIKES',
  INCOMPLETE_PENETRATION = 'INCOMPLETE_PENETRATION',
  OTHER_SUB_REASON = 'OTHER_SUB_REASON';

export const SendBackSubReasonMessages = {
  [SURFACE_CONTOUR]: defineMessage({ message: `Surface Contour` }),
  [WELD_SPATTER]: defineMessage({ message: `Weld Spatter` }),
  [ARC_STRIKES]: defineMessage({ message: `Arc Strikes` }),
  [INCOMPLETE_PENETRATION]: defineMessage({ message: `Incomplete Penetration` }),
  [OTHER_SUB_REASON]: defineMessage({ message: `Other` }),
  [MISMATCH]: defineMessage({
    message: `Mismatch`,
  }),
  [BEVEL_PREP]: defineMessage({
    message: `Blevel Prep`,
  }),
  [ROOT_OPENING]: defineMessage({
    message: `Root Opening`,
  }),
};
